module.exports = __webpack_public_path__ + "static/img/wuhanmylogo.d703a8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/wuhanmylogo.png
// module id = +NSd
// module chunks = 44